import {
    CaretRightOutlined,
    RightOutlined,
    MinusCircleOutlined,
    PlusOutlined,
    EditOutlined,
    CloseOutlined,
    DeleteOutlined
} from "@ant-design/icons";
import { Row, Col, Form, Input, Divider, Select, Button, Space, DatePicker, Table } from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import accountService from "../../../api/account.service";
import { DATE_FORMAT_DMY_SLASH, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";





const { Option } = Select;

const PaymentComponent = (props) => {
    const [accountList, setAccountList] = useState([]);
    const [paymentModeList, setPaymentModeList] = useState([]);
    const [bankList, setBankList] = useState([]);
    const [extraaPaidAmountInfo, setExtraaPaidAmountInfo] = useState("");

    const [isFisrtTimeComponentLoad, setIsFisrtTimeComponentLoad] = useState(false);
    const [isPaymentModereadOnlyDisable, setIsPaymentModereadOnlyDisable] = useState(false);
    // console.log("props payment",props);


    const columns = [
        {
            title: 'Mode',
            dataIndex: 'payment_mode_text',
            key: 'payment_mode_text',


        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (text, record, index) => (
                <div>
                    {
                        record.bank_charges > 0 ? <> <span>{record.amount}</span> <h5 style={{ fontStyle: 'italic', color: '#476f11', fontWeight: '700' }}>({record.amount - record.bank_charges} + {record.bank_charges})</h5> </> : <>{record.amount}</>
                    }

                </div>
            )

        },

        {
            title: 'Details',
            dataIndex: 'cheque_no',
            key: 'cheque_no',
            render: (text, record, index) => (
                <>
                    {
                        commonUtility.sanitizeObject(record?.payment_ref) != "" ?
                            <>
                                <h5>
                                    <span style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>Transaction / Reference Numbers / Card Details  </span>
                                </h5>
                                <p> {record?.payment_ref} </p>
                            </>
                            : ''
                    }

                    {
                        commonUtility.sanitizeObject(record?.cheque_no) != "" ? <h5><span style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>Ref No : </span> {record?.cheque_no}</h5> : ''
                    }

                    {
                        commonUtility.sanitizeObject(record?.cheque_date) != "" ? <h5><span style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>Date : </span> {record?.cheque_date}</h5> : ''
                    }

                    {
                        commonUtility.sanitizeObject(record?.bank_name) != "" ? <h5><span style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>Bank : </span> {record?.bank_name}</h5> : ''
                    }

                    {/* {
                    commonUtility.sanitizeObject(record?.bank_branch) !="" ? <h5><span style={{fontSize:'0.8rem',fontWeight:'bold'}}>Branch : </span> {record?.bank_branch}</h5> : ''
                } */}


                </>
            )

        },

        // {
        //     title: 'Cheque No',
        //     dataIndex: 'cheque_no',
        //     key: 'cheque_no',
        //  },
        // {
        //   title: 'Cheque No',
        //   dataIndex: 'cheque_no',
        //   key: 'cheque_no',
        // },
        // {
        //   title: 'Cheque Date',
        //   dataIndex: 'cheque_date',
        //   key: 'cheque_date',
        // },
        // {
        //   title: 'Bank',
        //   dataIndex: 'bank_name',
        //   key: 'bank_name',
        // },
        // {
        //   title: 'Branch',
        //   dataIndex: 'bank_branch',
        //   key: 'bank_branch',
        // },
        {
            title: 'Bank Charge',
            dataIndex: 'bank_charges',
            key: 'bank_charges',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record, index) => (
                <Button htmlType="button" type="ghost" size="small" shape="round" onClick={() => props.removePayment(index)} > Remove <DeleteOutlined /> </Button>
            )
        },



    ];


    useEffect(() => {
        if (props.admissionComponents && props.admissionComponents.length > 0) {
            console.log("PaymentComponent", props.admissionComponents);
        }
    }, [props.admissionComponents]);


    const onSelectPaymentMode = (value, object) => {

        //setIsPaymentModereadOnlyDisable(true) close on 27.06.2023
        //setIsFisrtTimeComponentLoad(false)

        props.enrollmentForm.setFieldsValue({
            cheque_no: '',
            cheque_date: '',
            bank: '',
            branch: '',
            payment_ref: '',
        });

        // if (commonUtility.sanitizeObject(object.payment_mode) && object.payment_mode == "Cheque") {
        // // if (commonUtility.sanitizeObject(value) && object.is_bank_details=="Y") {
        //     setIsPaymentModereadOnlyDisable(false)
        // }

        /*
        let bank_charges_amount = 0;
        const paid_amount = commonUtility.sanitizeValue(props.enrollmentForm.getFieldValue("paid_amount"));
        bank_charges_amount = ((parseFloat(paid_amount) * parseFloat(object.bank_charges))/100).toFixed(2);

        if(bank_charges_amount > 0) {
            setExtraaPaidAmountInfo(`For Bank Charges you have to pay Rs. ${bank_charges_amount} more`);
        }
        */


        props.enrollmentForm.setFieldsValue({
            selected_payment_mode_text: object.payment_mode,
            selected_payments_mode: object.id,
            dr_account_id: object.account_id,
            bank_charges: object.bank_charges,
        });

        onPaymentAmountChange(object)

    }

    const onPaymentAmountChange = (object = null) => {
        setExtraaPaidAmountInfo("");
        let bank_charges_amount = 0;
        const paid_amount = commonUtility.sanitizeValue(props.enrollmentForm.getFieldValue("paid_amount"));



        if (parseFloat(paid_amount) > 0) {
            let bank_charges_amount = 0;

            if (object != null) {
                bank_charges_amount = (parseFloat(paid_amount) * parseFloat(object.bank_charges)) / 100;
            } else {
                const bank_charges = commonUtility.sanitizeValue(props.enrollmentForm.getFieldValue("bank_charges"));
                bank_charges_amount = (parseFloat(paid_amount) * parseFloat(bank_charges)) / 100;
            }

            // Round the bank_charges_amount to the nearest whole number
            bank_charges_amount = Math.round(bank_charges_amount);

            if (bank_charges_amount > 0) {
                setExtraaPaidAmountInfo(`For Bank Charges you have to pay Rs. ${bank_charges_amount} more`);
            }
            //props.monthlyLoadComp({ paidtAmount: paid_amount });
        }
    
// console.log("monthlyLoadComp",);
    }

    const onPaymentDateSelect = (date, dateString) => {
        props.enrollmentForm.setFieldsValue({
            payment_date: dateString,
        });
    };


    const onChequeDateSelect = (date, dateString) => {
        props.enrollmentForm.setFieldsValue({
            cheque_date: dateString,
        });
    };


    useEffect(() => {
        accountService.accountList().then((res) => {
            setAccountList(res.data.response_data);
        });
    }, []);


    useEffect(() => {
        accountService.paymentModeList().then((res) => {
            setPaymentModeList(res.data.response_data);
        });
    }, [])


    useEffect(() => {
        accountService.bankList().then((res) => {
            setBankList(res.data.response_data);
        });
    }, [])


    useEffect(() => {
        props.enrollmentForm.setFieldsValue({
            paid_amount: props.remainingAmount.toFixed(2),
            short_excess_amount: props.remainingAmount.toFixed(2)
        })

        onPaymentAmountChange(null)
        //console.log("remainingAMount",props.remainingAmount.toFixed(2))
    }, [props.remainingAmount]);


    /*
    useEffect(()=> {
        props.enrollmentForm.setFieldsValue({
            adjust_receipt_id:props.shortAdjustmentData.adjust_receipt_id,
            adjust_amount:props.shortAdjustmentData.adjust_amount
        })
        onPaymentAmountChange(null)
    },[props.shortAdjustmentData]);
    */


    useEffect(() => {
        //console.log("props.paymentPaidList",props.paymentPaidList)
        setExtraaPaidAmountInfo("");

        props.enrollmentForm.setFieldsValue({
            payment_data: props.paymentPaidList
        });

    }, [props.paymentPaidList])


    useEffect(() => {
        setIsFisrtTimeComponentLoad(true);
    }, []);

    function disabledDate(current) {

        let sessionData = commonUtility.getLoggedInUserInfo();

        //console.log(sessionData.yearData.year);
        // Range of allowed dates        
        const startDate = new Date(sessionData.yearData.start_date); // Example start date
        const endDate = new Date(sessionData.yearData.end_date);   // Example end date

        // added 1 day to endDate as it is exclude while comparing (i.e March 31 is not selecting)
        endDate.setDate(endDate.getDate() + 1);

        // Return true if the date is not within the range
        return current < startDate || current > endDate;
    }

    const testSecurity = "N";

    
    

    return (
        <>


            <div>
                <Row gutter={20}>

                    <Col xs={24} xl={5}>
                        <Form.Item name="member_opening_balance" label="Opening Balance" hidden={true}>
                            <Input type="text" readOnly={true} />
                        </Form.Item>
                        <Form.Item name="date_of_payment" label="Receipt Date" rules={[
                            {
                                required: true,
                                message: "Payment date is required",
                            },
                        ]}>
                            <DatePicker
                                format={DATE_FORMAT_DMY_SLASH}
                                style={{ width: "100%" }}
                                inputReadOnly={true}
                                disabledDate={disabledDate} // Set the disabledDate function
                                onChange={onPaymentDateSelect}
                            />
                        </Form.Item>
                        <Form.Item name="payment_date" hidden={true}>
                            <Input type="text" />
                        </Form.Item>

                    </Col>

                    <Col xs={24} xl={6}  >
                        <Form.Item name="payment_no" label="Receipt No." >
                            <Input type="text" readOnly={true} />
                        </Form.Item>
                    </Col>

                    <Col xs={24} xl={6} hidden={!props.shortAdjustmentData ? true : false}>
                        <Form.Item name="adjust_amount" label="Short/Excess Amount" >
                            <Input type="text" readOnly={true} />
                        </Form.Item>
                        <Form.Item name="adjust_receipt_id" label="Short/Excess Amount" hidden={true}>
                            <Input type="text" readOnly={true} />
                        </Form.Item>
                    </Col>

                    <Col xs={24} xl={10} hidden={true}>

                        <Form.Item name="narration" label="Narration" >
                            <TextArea placeholder="" autoSize={{ minRows: 2, maxRows: 6, }} />
                        </Form.Item>

                    </Col>
                </Row>


                <Row gutter={20}>
                    <Col xs={24} xl={5}>
                        <Form.Item
                            label="Receipt Mode"
                            name="selected_payments_mode"
                        // rules={[
                        //     {
                        //       required: false,
                        //       message: "Mode is required",
                        //     },
                        //   ]}
                        >
                            <Select
                                className="text-left"
                                defaultValue="Select"
                                //name="selected_payments_mode"
                                onSelect={(value, event) => onSelectPaymentMode(value, event)}
                                allowClear={true}
                            // disabled={props.isPaymentModeDisabled}
                            >

                                <Option key="0" value="0" id="0" payment_mode="" account_id="0" account_name="" >Select</Option>



                                {paymentModeList.length > 0
                                    ? paymentModeList.map((payment_mode_list) => (
                                        <Option
                                            key={payment_mode_list.id}
                                            value={payment_mode_list.id}

                                            id={payment_mode_list.id}
                                            payment_mode={payment_mode_list.payment_mode}
                                            account_id={payment_mode_list.account_id}
                                            account_name={payment_mode_list.account_name}
                                            is_bank_details={payment_mode_list.is_bank_details}
                                            bank_charges={payment_mode_list.bank_charges}
                                        >
                                            {payment_mode_list.payment_mode} {payment_mode_list.bank_charges > 0 ? payment_mode_list.bank_charges + "%" : ""}
                                        </Option>
                                    ))
                                    : ""}


                            </Select>


                        </Form.Item>

                        <Form.Item name="selected_payment_mode_text" label="" hidden={true} >
                            <Input type="text" />
                        </Form.Item>

                        <Form.Item name="dr_account_id" label="" hidden={true} >
                            <Input type="text" />
                        </Form.Item>
                        <Form.Item name="payment_data" label="" hidden={true} >
                            <Input type="text" />
                        </Form.Item>

                    </Col>

                    {/* {props.admissionComponents && ( */}
                        <Col xs={24} xl={3}>
                            <Form.Item
                                name="paid_amount"
                                label="Amount"
                                rules={[
                                    {
                                        required: false,
                                        message: "Amount is required",
                                    },
                                ]}
                                onChange={() => onPaymentAmountChange(null)}
                                
                            >
                                <Input
                                    type="text"
                                    //readOnly={props.admissionComponents && props.admissionComponents.length > 0}
                                    // readOnly={
                                    //     ((props.admissionComponents && props.admissionComponents.length > 0) || (props.depositTrigger === "N"))
                                    //   }
                                    readOnly={true}
                                      
                                />
                            </Form.Item>
                            <Form.Item name="short_excess_amount" hidden={true}>
                                <Input type="text"  />
                            </Form.Item>
                        </Col>
                    {/* )} */}


                    {/* <Col xs={24} xl={9} hidden={!isPaymentModereadOnlyDisable} > */}
                    <Col xs={24} xl={9} hidden={true} >
                        <Form.Item name="payment_ref" label="Transaction / Reference Numbers / Card Details" >
                            <TextArea maxLength={100} rows={1} />
                        </Form.Item>
                    </Col>
                    {/* <Col xs={24} xl={3} hidden={isPaymentModereadOnlyDisable || isFisrtTimeComponentLoad} >
                    <Form.Item name="cheque_no" label="Number" >
                        <Input type="text" readOnly={isPaymentModereadOnlyDisable} />
                    </Form.Item>
                </Col> */}
                    <Col xs={24} xl={3}  >
                        <Form.Item name="cheque_no" label="Ref. No" >
                            <Input type="text" readOnly={isPaymentModereadOnlyDisable} />
                        </Form.Item>
                    </Col>
                    {/* <Col xs={24} xl={4} hidden={isPaymentModereadOnlyDisable || isFisrtTimeComponentLoad}>
                    <Form.Item name="cheque_date" label="" hidden={true} >
                        <Input type="text" readOnly={isPaymentModereadOnlyDisable} />
                    </Form.Item>

                    <Form.Item name="cheque_date_picker" label="Date">
                        <DatePicker
                            format={DATE_FORMAT_DMY_SLASH}
                            style={{ width: "100%" }}
                            inputReadOnly={true}
                         onChange={onChequeDateSelect}

                        />
                    </Form.Item>
                </Col> */}
                    <Col xs={24} xl={4}>
                        <Form.Item name="cheque_date" label="" hidden={true} >
                            <Input type="text" readOnly={isPaymentModereadOnlyDisable} />
                        </Form.Item>

                        <Form.Item name="cheque_date_picker" label="Date">
                            <DatePicker
                                format={DATE_FORMAT_DMY_SLASH}
                                style={{ width: "100%" }}
                                inputReadOnly={true}
                                onChange={onChequeDateSelect}

                            />
                        </Form.Item>
                    </Col>
                    {/* <Col xs={24} xl={5} hidden={isPaymentModereadOnlyDisable || isFisrtTimeComponentLoad}>
                    <Form.Item name="bank" label="Bank" >
                        <Input type="text" readOnly={isPaymentModereadOnlyDisable} />
                    </Form.Item>
                </Col> */}
                    <Col xs={24} xl={6}>
                        <Form.Item name="bank" label="Bank" >
                            <Select
                                className="text-left"
                                defaultValue="Select"
                                //name="selected_payments_mode"
                                //onSelect={(value, event) => onSelectPaymentMode(value, event)}
                                allowClear={true}

                                // if we need select in first then we have to comment below codes ---edit by dipten (12.02.2025)
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    //option.children.includes(input)
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children
                                        .toLowerCase()
                                        .localeCompare(optionB.children.toLowerCase())
                                }

                            >

                                <Option key="0" value="0">Select</Option>



                                {bankList.length > 0
                                    ? bankList.map((bank_list) => (
                                        <Option
                                            key={bank_list.bank_id}
                                            value={bank_list.bank_name}>
                                            {bank_list.bank_name}
                                        </Option>
                                    ))
                                    : ""}


                            </Select>
                        </Form.Item>
                    </Col>
                    {/* <Col xs={24} xl={4} hidden={isPaymentModereadOnlyDisable || isFisrtTimeComponentLoad}> */}
                    <Col xs={24} xl={4} hidden={true}>
                        <Form.Item name="branch" label="Branch" >
                            <Input type="text" readOnly={isPaymentModereadOnlyDisable} />
                        </Form.Item>
                        <Form.Item name="bank_charges" label="Bank Charges" hidden={true} >
                            <Input type="text" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} xl={2}>
                        <Form.Item name="" label=" ">
                            <Button
                                htmlType="button"
                                className="custom-button-green"
                                icon={<PlusOutlined />}
                                onClick={props.addPaymentMode}
                                disabled={props.isPaymentModeDisabled}
                            >
                                Add
                            </Button>
                        </Form.Item>
                    </Col>

                    {/* <Col xs={24} xl={3}>
                    <Form.Item name="branch" label=" ">
                    <Button type="primary" block>
                        Edit
                    </Button>
                    
                    </Form.Item>
                </Col>
                <Col xs={24} xl={3}>
                    <Form.Item name="branch" label=" ">
                   
                    <Button type="primary" block>
                        Remove
                    </Button>
                    </Form.Item>
                </Col> */}
                </Row>

                <Row>
                    <Col>
                        <span style={{
                            color: "#22661c",
                            fontWeight: "700",
                            fontSize: "13px"
                        }}>{extraaPaidAmountInfo}</span>
                    </Col>
                    {/* <Col xs={24} xl={24} ><span>Note: Payment Mode , Amount should not be blank </span></Col> */}
                </Row>


                {
                    props.paymentPaidList.length > 0 ? <><Table rowKey="rowKey" size="small" columns={columns} dataSource={props.paymentPaidList} pagination={false} /></> : ''
                }
            </div>
        </>
    )
}

export default PaymentComponent